import React from "react";
import DatePicker from "./DatePicker";
import type { Filter } from "features/AssetResults/types";

export type FilterDatePickerProps = {
  filter: Record<string, any>;
  filterDateValues: string;
  updateFilter: (filter: Filter, newValue: any) => void;
  className?: string;
  placeholder: "From" | "To";
  verticalPosition?: "top" | "bottom";
  horizontalPosition?: "auto" | "left" | "right";
  disabled?: boolean;
  popupPosition?:
    | "top left"
    | "top right"
    | "bottom left"
    | "bottom right"
    | "right center"
    | "left center"
    | "top center"
    | "bottom center";
  minDate?: string;
  maxDate?: string;
};

const FilterDatePicker: React.FC<FilterDatePickerProps> = ({
  filter,
  filterDateValues,
  updateFilter,
  className,
  placeholder,
  verticalPosition,
  horizontalPosition,
  disabled,
  popupPosition,
  minDate,
  maxDate,
}) => {
  type FilterChangeEvent = { value: string };

  const handleFilterChange = (_: unknown, { value }: FilterChangeEvent) => {
    const newFilter = { ...filter };

    if (value !== "") {
      newFilter["dates"] = {
        ...newFilter["dates"],
        [placeholder.toLowerCase()]: value,
      };
    }

    updateFilter(newFilter as Filter, {
      from: newFilter.dates?.from || minDate || "",
      to: newFilter.dates?.to || maxDate || "",
    });
  };

  return (
    <DatePicker
      value={filterDateValues}
      className={className}
      placeholder={placeholder}
      onChange={handleFilterChange}
      disabled={disabled}
      verticalPosition={verticalPosition}
      horizontalPosition={horizontalPosition}
      popupPosition={popupPosition}
      minDate={minDate}
      maxDate={maxDate}
    />
  );
};

export default FilterDatePicker;
